var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdTypeRecommend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 84,
    viewBox: "0 0 110 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59124_11251)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 84,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5992 50.3443C2.59919 50.3443 2.59918 50.3443 2.59916 50.3443C-2.65795 51.9884 -5.58688 57.583 -3.94279 62.8401C-2.2987 68.0972 3.29583 71.0261 8.55294 69.382C8.55295 69.382 8.55297 69.382 8.55298 69.382L2.5992 50.3443Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0416 32.8248C65.2986 31.1807 70.8931 34.1097 72.5372 39.3668C74.1813 44.6238 71.2524 50.2183 65.9953 51.8625L60.0416 32.8248Z",
    fill: "#A6C1EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6946 66.9777L71.5056 69.4825L54.3916 14.7593L10.774 48.0463L16.6946 66.9777Z",
    fill: "url(#paint0_linear_59124_11251)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7003 47.8108L2.59912 50.3443L16.7235 95.5082L16.7236 95.5082L16.7237 95.5083C17.4233 97.7454 19.8039 98.9918 22.041 98.2922C24.2781 97.5925 25.5244 95.2119 24.8248 92.9748L24.8247 92.9746L24.8246 92.9746L10.7003 47.8108Z",
    fill: "#5C63AB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.7712,
    y: 14.5605,
    width: 8.48806,
    height: 61.3263,
    transform: "rotate(-17.3664 48.7712 14.5605)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 26.5882C2.71573 26.5882 -4 22.8748 -4 18.2941C-4 13.7134 2.71573 10 11 10C19.2843 10 26 13.7134 26 18.2941C26 21.4664 22.7792 24.2227 18.0471 25.6178L16.8469 27.9738C16.6168 28.4255 15.9715 28.4255 15.7414 27.9738L14.8919 26.3063C13.6508 26.4902 12.3461 26.5882 11 26.5882Z",
    fill: "#413993"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97 59.5882C88.7157 59.5882 82 55.8748 82 51.2941C82 46.7134 88.7157 43 97 43C105.284 43 112 46.7134 112 51.2941C112 54.4824 108.747 57.2505 103.975 58.6388C103.962 58.7429 103.93 58.8475 103.878 58.9491L103.146 60.3851C102.792 61.0816 101.797 61.0816 101.442 60.3851L100.892 59.3063C99.6509 59.4902 98.3462 59.5882 97 59.5882Z",
    fill: "#413993"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 32.1765C107.569 32.1765 121 24.7497 121 15.5882C121 6.42681 107.569 -1 91 -1C74.4315 -1 61 6.42681 61 15.5882C61 21.9328 67.4417 27.4454 76.9059 30.2356L79.3063 34.9475C79.7664 35.8509 81.057 35.8509 81.5172 34.9475L83.2161 31.6126C85.6985 31.9804 88.3078 32.1765 91 32.1765Z",
    fill: "url(#paint1_linear_59124_11251)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 107,
    height: 81,
    rx: 1.5,
    stroke: "#413993",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59124_11251",
    x1: 45.0212,
    y1: 30.2963,
    x2: -4.74473,
    y2: 71.2952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8991DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6C1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59124_11251",
    x1: 61,
    y1: 17.3125,
    x2: 121,
    y2: 17.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6C1EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59124_11251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 84,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdTypeRecommend);
export default __webpack_public_path__ + "static/media/adType_recommend.06ee97d6f721cdd762684eceef514c0c.svg";
export { ForwardRef as ReactComponent };